import { Injectable } from '@angular/core';
import { Breadcrumbs, WebHeaderControlOptions } from '../../types/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { Resident } from '../../../shared/models/resident.model';

@Injectable({
  providedIn: 'root',
})
export class WebHeaderOptionsService {
  private webHeaderControlOptions =
    new BehaviorSubject<WebHeaderControlOptions>(null);
  private titleSubject = new BehaviorSubject<string>('');
  private breadcrumbsSubject = new BehaviorSubject<Breadcrumbs[]>([]);
  private pageResident = new BehaviorSubject<Resident | null>(null);

  setTitle(title: string): void {
    this.titleSubject.next(title);
  }

  getTitle(): Observable<string> {
    return this.titleSubject.asObservable();
  }

  setBreadcrumbs(breadcrumbs: Breadcrumbs[]): void {
    this.breadcrumbsSubject.next(breadcrumbs);
  }

  getBreadcrumbs(): Observable<Breadcrumbs[]> {
    return this.breadcrumbsSubject.asObservable();
  }

  setWebHeaderOptions(options: WebHeaderControlOptions): void {
    this.webHeaderControlOptions.next({
      control: options?.control || null,
      option1: options?.option1 || '',
      option2: options?.option2 || '',
      option1Icon: options?.option1Icon || '',
      option2Icon: options?.option2Icon || '',
    });
  }

  getWebHeaderOptions(): Observable<WebHeaderControlOptions> {
    return this.webHeaderControlOptions.asObservable();
  }

  setPageResident(resident: Resident | null): void {
    this.pageResident.next(resident);
  }

  getPageResident(): Observable<Resident | null> {
    return this.pageResident.asObservable();
  }
}
